export default __webpack_public_path__ + "media/Portrait_Placeholder.157f088b56f86d22066e6df568cbb134.png";